import React from 'react';

import { useSelector } from 'react-redux';

import {
  getCurrentPullRequest,
  getPullRequestDestinationHash,
  getPullRequestSourceHash,
} from 'src/redux/pull-request/selectors';

import {
  BrokenDiffMessage,
  MissingDiffMessage,
  MissingDiffOnMergedPrMessage,
  UnhandledMergeConflictsMessage,
  DiffTimeoutMessage,
  NoCommonAncestorMessage,
  AmbiguousRefsMessage,
} from './diff-error-messages';

export interface DiffErrorsProps {
  errorCodeString: string;
  errorKey: string | null;
}

export const DiffErrors = ({
  errorCodeString,
  errorKey,
}: DiffErrorsProps): JSX.Element | null => {
  const is400 = errorCodeString.startsWith('4');
  const is500 = errorCodeString.startsWith('5');
  const is555 = errorCodeString === '555';
  const isUnhandledMergeConflicts500 = is500 && errorKey === 'MERGE_CONFLICT';
  const currentPullRequest =
    useSelector(getCurrentPullRequest) || ({} as Partial<BB.PullRequest>);
  const mergeCommit = currentPullRequest?.merge_commit;

  const destinationHash = useSelector(getPullRequestDestinationHash) || '';
  const sourceHash = useSelector(getPullRequestSourceHash) || '';

  if (is400) {
    if (mergeCommit) {
      return MissingDiffOnMergedPrMessage(mergeCommit);
    } else if (errorKey === 'NO_COMMON_ANCESTOR') {
      return <NoCommonAncestorMessage />;
    } else if (errorKey === 'AMBIGUOUS_SPEC') {
      return (
        <AmbiguousRefsMessage
          sourceHash={sourceHash}
          destinationHash={destinationHash}
        />
      );
    } else {
      return <MissingDiffMessage />;
    }
  }

  if (is555) {
    return <DiffTimeoutMessage />;
  }

  if (isUnhandledMergeConflicts500) {
    return <UnhandledMergeConflictsMessage />;
  }

  if (is500) {
    return <BrokenDiffMessage />;
  }

  return null;
};
